import * as React from 'react';
import clsx from 'clsx';

interface Props {
  className?: string;
}

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
export const FormActions: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  className,
  children,
}) => <section className={clsx('FormActions', className)}>{children}</section>;
